import { EyeOutlined, DeleteOutlined } from "@ant-design/icons";
import Login from "./pages/Login";
import AssignCalls from "./dashboards/superAdmin/AssignCalls";
import AssignedCalls from "./dashboards/superAdmin/AssignedCalls";
import ManageQAs from "./dashboards/superAdmin/ManageQAs";
import AuditDetails from "./dashboards/QA/AuditDetails";
import CompleteCalls from "./dashboards/superAdmin/CompleteCalls";
import AdminDashboard from "./dashboards/superAdmin/Dashboard";
import QADashboard from "./dashboards/QA/Dashboard";
import { useSelector } from "react-redux";
import Unauthorized from "./pages/Unauthorized";
import ReportPdf from "./components/ReportPdf";
import AuditedCalls from "./dashboards/QA/AuditedCalls";
import PktQuestionnaire from "./dashboards/superAdmin/PktQuestionnaire";
import TraineeDashboard from "./dashboards/trainee/Dashboard";
import { AssignedCallsToQL } from "./dashboards/QA/AssignedCallsToQL";
import AssignedCallsByQL from "./dashboards/QA/AssignedCallsByQL";
import CallCalibration from "./dashboards/superAdmin/CallCalibration";


export const roleNames = {
  superAdmin: "super_admin",
  admin: "admin",
  qa: "qa",
  qualityLead: "qualitylead",
  qualityAssurance: "qualityassurance",
  opsTeamLead: "opsteamlead",
  opsLead: "opslead",
  trainer: "trainer",
  traininglead: "traininglead",
  trainee: "trainee",
};
export const roleDisplayNames = {
  super_admin: "Super Admin",
  admin: "Admin",
  qa: "Quality Analyst",
  qualitylead: "Quality Lead",
  qualityassurance: "Quality Assurance",
  opsteamlead: "Ops Team Lead",
  opslead: "Ops Lead",
  trainer: "Trainer",
  traininglead: "Training Lead",
};

export const QA_DASHBOARD_ROLES = [
  roleNames.opsTeamLead,
  roleNames.opsLead,
  roleNames.trainer,
  roleNames.traininglead,
];
export const roleIds = {
  superAdmin: 1,
  qa: 2,
  trainee: 10,
};
// constants/role.constants.js
export const ADMIN_ROLES = [roleNames.superAdmin, roleNames.admin];

export const QA_ROLES = [
  roleNames.qa,
  roleNames.qualityLead,
  roleNames.qualityAssurance,
  roleNames.opsTeamLead,
  roleNames.opsLead,
  roleNames.trainer,
  roleNames.traininglead,
  roleNames.trainee,
];
export const roleIdToNameMap = {
  1: "SUPER_ADMIN",
  2: "QA",
  3: "ADMIN",
  4: "QualityLead",
  5: "QualityAssurance",
  6: "OpsTeamLead",
  7: "OpsLead",
  8: "Trainer",
  9: "TrainingLead",
  10: "TRAINEE",
};

export const zoneIdToNameMap = {
  1: "HA",
  2: "DR",
  3: "Bangalore_Treline",
  4: "Bangalore_Cimmons",
  5: "Treline_Gurgaon",
  6: "I-Collect",
  7: "Samavesh",
};

export const linkArray = [
  {
    title: "Dashboard",
    icon: "bi bi-speedometer2",
    adminPath: "/admin-dashboard",
    qaPath: "/qa-dashboard",
  },
  {
    title: "Assign calls",
    icon: "bi bi-telephone-plus",
    adminPath: "/assign-calls",
    qaPath: "/assign-calls",
  },
  {
    title: "Assigned calls",
    icon: "bi bi-telephone-forward",
    adminPath: "/assigned-calls",
    qaPath: "/assigned-calls",
    additionalPaths: ["audit-details"],
  },
    {
    title: "Assigned calls to QL",
    icon: "bi bi-telephone-forward",
    qaPath: "/assigned-calls-to-ql",
    additionalPaths: ["audit-details"],
  },
    {
    title: "Assigned calls to QA(Assurance)",
    icon: "bi bi-telephone-forward",
    qaPath: "/assigned-calls-to-qa",
    additionalPaths: ["audit-details"],
  },

    {
    title: "Assigned calls by QL",
    icon: "bi bi-telephone-inbound",
    qaPath: "/assigned-calls-by-ql",

  },
      {
    title: "Calibration panel",
    icon: "bi bi-headset",
    qaPath: "/call-calibration",
    adminPath: "/call-calibration",

  },
  {
    title: "Audited calls",
    icon: "bi bi-check-circle",
    adminPath: "/audited-calls",
    qaPath: "/audited-calls",
  },
  {
    title: "Callibration Assigned Calls",
    icon: "bi bi-telephone-forward",
    qaPath: "/callibration-assigned-calls",
  },
  {
    title: "Callibration Audited Calls",
    icon: "bi bi-check-circle",
    qaPath: "/callibration-audited-calls",
  },
  {
    title: "Completed calls",
    icon: "bi bi-check-circle-fill",
    adminPath: "/completed-calls",
    qaPath: "/completed-calls",
  },
  {
    title: "Manage users",
    icon: "bi bi-people",
    adminPath: "/manage-qas",
    qaPath: "/manage-qas",
  },
  // {
  //   title: "Manage Trainers",
  //   icon: "bi bi-people",
  //   qaPath: "/manage-trainer",
  // },
  // {
  //   title: "Manage Trainee",
  //   icon: "bi bi-people",
  //   qaPath: "/manage-trainee",
  // },
  {
    title: "PKT Questionnaire",
    icon: "bi bi-ui-checks",
    adminPath: "/pkt-questionnaire",
    qaPath: "/pkt-questionnaire",
  },
  // {
  //   title: "Settings",
  //   icon: "bi bi-gear",
  //   adminPath: "/settings",
  //   qaPath: "/qa-dashboard",
  // },
  {
    title: "Log out",
    icon: "bi bi-arrow-left-circle",
    adminPath: "/login",
    qaPath: "/qa-dashboard",
  },
];

export const menuItems = [
  {
    key: "1",
    label: "View details",
    icon: <EyeOutlined />,
  },
  {
    key: "2",
    label: "Delete call",
    icon: <DeleteOutlined />,
  },
];

export const publicRoutes = [{ element: <Login />, path: "/login" }];

export const privateRoutes = [
  {
    element: <AdminDashboard />,
    path: "/admin-dashboard",
    roles: [roleNames.superAdmin],
  },
  {
    element: <AssignCalls />,
    path: "/assign-calls",
    roles: [roleNames.superAdmin, roleNames.qa],
  },
  {
    element: <AssignedCalls  key="normal-assigned" isCalibrationMode={false}  />,
    path: "/assigned-calls",
    roles: [roleNames.superAdmin, roleNames.qa, roleNames.traininglead, 
      roleNames.opsLead, roleNames.opsTeamLead, roleNames.trainer],
  },
  {
    element: <AssignedCalls type="qualityAssurance" />,
    path: "/assigned-calls-to-qa",
    roles: [ roleNames.qualityAssurance],
  },
  {
    element: <AssignedCallsToQL />,
    path: "/assigned-calls-to-ql",
    roles: [roleNames.qa],
  },
  {
    element: <AssignedCallsByQL />,
    path: "/assigned-calls-by-ql",
    roles: [roleNames.qa],
  },
    {
    element: <CallCalibration />,
    path: "/call-calibration",
    roles: [roleNames.superAdmin,roleNames.qa],
  },
  {
    element: <AuditedCalls key="normal-audited" isCalibrationMode={false} />,
    path: "/audited-calls",
    roles: [roleNames.superAdmin, roleNames.qa],
  },
  {
    element: <ManageQAs />,
    path: "/manage-qas",
    roles: [roleNames.superAdmin],
  },
  {
    element: <QADashboard />,
    path: "/qa-dashboard",
    roles: [roleNames.qa],
  },
  {
    element: <AuditDetails />,
    path: "/audit-details/:id",
    roles: [roleNames.qa],
  },
  {
    element: <AuditedCalls key="calibration-audited" isCalibrationMode={true} />,
    path: "/callibration-audited-calls",
    roles: [roleNames.qa],
  },
   {
    element: <AssignedCalls key="calibration-assigned" isCalibrationMode={true} />,
    path: "/callibration-assigned-calls",
    roles: [roleNames.qa],
  },
  {
    element: <CompleteCalls />,
    path: "/completed-calls",
    roles: [roleNames.superAdmin, roleNames.qa],
  },
  {
    element: <ReportPdf />,
    path: "/report-pdf",
    roles: [roleNames.superAdmin, roleNames.qa],
    showLayout: false,
  },
  {
    element: <PktQuestionnaire />,
    path: "/pkt-questionnaire",
    roles: [roleNames.traininglead, roleNames.superAdmin],
  },
  {
    element: <QADashboard />,
    path: "/manage-trainer",
    roles: [roleNames.traininglead],
  },
  {
    element: <QADashboard />,
    path: "/manage-trainee",
    roles: [roleNames.trainer, roleNames.traininglead],
  },
  {
    element: <TraineeDashboard />,
    path: "/trainee-dashboard",
    roles: [roleNames.trainee],
    showLayout: false,
  },
  {
    element: <Unauthorized />,
    path: "/unauthorized",
    roles: [roleNames.superAdmin, roleNames.qa],
    showLayout: false,
  },
];

export const qaTypeButtons = [
  { id: 1, label: "Transactional" },
  { id: 2, label: "Transformational" },
  { id: 3, label: "Hygiene" },
  { id: 4, label: "Disposition" },
];

export const commonRule = [
  {
    required: true,
    message: "Please enter your password!",
  },
  {
    min: 6,
    message: "Password must be at least 6 characters long!",
  },
];

export const dropdownQuestionIds = {
  1: [], // Transactional
  2: [2, 3, 4, 5], // Transpositional
  3: [], // Hygiene
  4: [], // Disposition
};

export const filterDataFunc = (data, searchText) => {
  return data?.filter((item) =>
    Object.values(item).join(" ").toLowerCase().includes(searchText.trim().toLowerCase()),
  );
};
